
import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import AnimatedLogo from '../base/AnimatedLogo';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isActive = (path: string) => location.pathname === path;
  
  // Check if we're on the home page
  const isHomePage = location.pathname === '/';
  
  // On non-home pages, always show white background with dark text
  const shouldShowWhiteBg = !isHomePage || isScrolled;

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        shouldShowWhiteBg ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="w-full px-6 lg:px-12 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <AnimatedLogo isScrolled={shouldShowWhiteBg} />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-8">
            <Link
              to="/"
              className={`font-semibold text-sm tracking-wide transition-colors ${
                shouldShowWhiteBg
                  ? isActive('/')
                    ? 'text-orange'
                    : 'text-charcoal hover:text-orange'
                  : isActive('/')
                  ? 'text-orange'
                  : 'text-white hover:text-orange'
              }`}
            >
              Home
            </Link>
            <Link
              to="/services"
              className={`font-semibold text-sm tracking-wide transition-colors ${
                shouldShowWhiteBg
                  ? isActive('/services')
                    ? 'text-orange'
                    : 'text-charcoal hover:text-orange'
                  : isActive('/services')
                  ? 'text-orange'
                  : 'text-white hover:text-orange'
              }`}
            >
              Services
            </Link>
            <Link
              to="/about"
              className={`font-semibold text-sm tracking-wide transition-colors ${
                shouldShowWhiteBg
                  ? isActive('/about')
                    ? 'text-orange'
                    : 'text-charcoal hover:text-orange'
                  : isActive('/about')
                  ? 'text-orange'
                  : 'text-white hover:text-orange'
              }`}
            >
              About Us
            </Link>
            <a
              href="#contact"
              className={`font-semibold text-sm tracking-wide transition-colors cursor-pointer ${
                shouldShowWhiteBg ? 'text-charcoal hover:text-orange' : 'text-white hover:text-orange'
              }`}
            >
              Contact
            </a>

            <a
              href="#contact"
              className="bg-orange text-white px-6 py-3 font-semibold text-sm tracking-wide hover:bg-orange/90 transition-colors whitespace-nowrap cursor-pointer"
            >
              Get a Quote
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`lg:hidden w-10 h-10 flex items-center justify-center transition-colors cursor-pointer ${
              shouldShowWhiteBg ? 'text-charcoal' : 'text-white'
            }`}
          >
            <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden mt-6 pb-6 space-y-4 bg-white rounded-lg shadow-lg p-6">
            <Link
              to="/"
              onClick={() => setIsMobileMenuOpen(false)}
              className={`block font-semibold text-sm tracking-wide ${
                isActive('/') ? 'text-orange' : 'text-charcoal hover:text-orange'
              }`}
            >
              Home
            </Link>
            <Link
              to="/services"
              onClick={() => setIsMobileMenuOpen(false)}
              className={`block font-semibold text-sm tracking-wide ${
                isActive('/services') ? 'text-orange' : 'text-charcoal hover:text-orange'
              }`}
            >
              Services
            </Link>
            <Link
              to="/about"
              onClick={() => setIsMobileMenuOpen(false)}
              className={`block font-semibold text-sm tracking-wide ${
                isActive('/about') ? 'text-orange' : 'text-charcoal hover:text-orange'
              }`}
            >
              About Us
            </Link>
            <a
              href="#contact"
              onClick={() => setIsMobileMenuOpen(false)}
              className="block font-semibold text-sm tracking-wide text-charcoal hover:text-orange cursor-pointer"
            >
              Contact
            </a>

            <a
              href="#contact"
              onClick={() => setIsMobileMenuOpen(false)}
              className="block bg-orange text-white px-6 py-3 font-semibold text-sm tracking-wide text-center hover:bg-orange/90 transition-colors whitespace-nowrap cursor-pointer"
            >
              Get a Quote
            </a>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
